import React from 'react';
import { Trophy, Users, Zap } from 'lucide-react';
import '../styles/tournament-bracket.css';

const TournamentBracket = () => {
  return (
    <div className="tournament-bracket">
      {/* Header */}
      <div className="bracket-header">
        <Trophy size={20} />
        <span>Live Tournament</span>
      </div>

      {/* Bracket Structure */}
      <div className="bracket-container">
        {/* Quarter Finals */}
        <div className="bracket-round quarter-finals">
          <div className="round-label">Quarter Finals</div>
          <div className="bracket-matches">
            <div className="match">
              <div className="player winner">
                <span className="player-name">ShadowReaper</span>
                <span className="score">6</span>
              </div>
              <div className="player">
                <span className="player-name">BlazeVortex</span>
                <span className="score">2</span>
              </div>
            </div>
            <div className="match">
              <div className="player winner">
                <span className="player-name">XxDeadShotxX</span>
                <span className="score">9</span>
              </div>
              <div className="player">
                <span className="player-name">FrostByte</span>
                <span className="score">5</span>
              </div>
            </div>
            <div className="match">
              <div className="player winner">
                <span className="player-name">VenomDrift</span>
                <span className="score">7</span>
              </div>
              <div className="player">
                <span className="player-name">NoScopeKing</span>
                <span className="score">4</span>
              </div>
            </div>
            <div className="match">
              <div className="player winner">
                <span className="player-name">CrimsonWolf</span>
                <span className="score">2</span>
              </div>
              <div className="player">
                <span className="player-name">GhostN1nja</span>
                <span className="score">1</span>
              </div>
            </div>
          </div>
        </div>

        {/* Semi Finals */}
        <div className="bracket-round semi-finals">
          <div className="round-label">Semi Finals</div>
          <div className="bracket-matches">
            <div className="match">
              <div className="player winner">
                <span className="player-name">ShadowReaper</span>
                <span className="score">6</span>
              </div>
              <div className="player">
                <span className="player-name">XxDeadShotxX</span>
                <span className="score">4</span>
              </div>
            </div>
            <div className="match">
              <div className="player winner">
                <span className="player-name">VenomDrift</span>
                <span className="score">8</span>
              </div>
              <div className="player">
                <span className="player-name">CrimsonWolf</span>
                <span className="score">6</span>
              </div>
            </div>
          </div>
        </div>

        {/* Finals */}
        <div className="bracket-round finals">
          <div className="round-label">Finals</div>
          <div className="bracket-matches">
            <div className="match final-match">
              <div className="player winner">
                <span className="player-name">ShadowReaper</span>
                <span className="score">2</span>
              </div>
              <div className="player">
                <span className="player-name">VenomDrift</span>
                <span className="score">1</span>
              </div>
            </div>
          </div>
        </div>

        {/* Winner */}
        <div className="winner-section">
          <div className="winner-crown">
            <Trophy size={24} />
          </div>
          <div className="winner-info">
            <span className="winner-label">Champion</span>
            <span className="winner-name">ShadowReaper</span>
            <span className="winner-prize">$1,000 Prize</span>
          </div>
        </div>
      </div>

      {/* Live Stats */}
      <div className="bracket-stats">
        <div className="stat">
          <Users size={16} />
          <span>128 Players</span>
        </div>
        <div className="stat">
          <Zap size={16} />
          <span>Live</span>
        </div>
      </div>
    </div>
  );
};

export default TournamentBracket; 